import ApiClient from "../helpers/ApiClient";

const baseSessionEndpoint = `/GetSession`;

const getSession = () =>
  ApiClient.backendClient.get(baseSessionEndpoint, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const SessionApiClient = { getSession };
export default SessionApiClient;
